export const WHATSAPP_NUMBER = '923147046916';
export const WHATSAPP_DISPLAY = '+92 314 7046916';
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;

export function whatsappLink(prefilledMessage?: string): string {
  if (!prefilledMessage) return WHATSAPP_URL;
  return `${WHATSAPP_URL}?text=${encodeURIComponent(prefilledMessage)}`;
}

export const CONTACT_EMAIL = 'hello@orvexaco.com';

// International (UK) phone line.
export const INTL_PHONE = '+447780309843';
export const INTL_PHONE_DISPLAY = '+44 7780 309843';
export const INTL_PHONE_URL = `tel:${INTL_PHONE}`;
